import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../REDUX/actions/products";

const CustomSelect = ({ handleChange, value }) => {
  const dispatch = useDispatch();
  const [typeSelected, settypeSelected] = useState(0);
  const { productsIdAndNames } = useSelector((state) => state.productsReducer);

  useEffect(() => {
    if (!productsIdAndNames) {
      dispatch(getAllProducts());
    }
    // eslint-disable-next-line
  }, []);

  const buttonTypes = [
    {
      text: "Page du Site",
      value: 0,
    },
    {
      text: "Vers un produit",
      value: 1,
    },
    {
      text: "Lien Externe",
      value: 2,
    },
  ];
  const sitePages = [
    {
      text: "Page Home",
      value: "/",
    },
    {
      text: "Page Nos avantages",
      value: "/nos-avantages",
    },
    {
      text: "Page Notre Histoire",
      value: "/notre-histoire",
    },
    {
      text: "Page SAV",
      value: "/garantie-sav",
    },
    {
      text: "Page Nos réalisations",
      value: "/nos-realisations",
    },
    {
      text: "Page Nos Gammes Spa",
      value: "/nos-gammes-spa",
    },
    {
      text: "Page Nos Gammes Spa de Nage",
      value: "/nos-gammes-spa-de-nage",
    },
    {
      text: "Page Nos Gammes Sauna",
      value: "/nos-gammes-sauna",
    },
    {
      text: "Page Trouver un showroom",
      value: "/magasins",
    },
    {
      text: "Page Nos événements",
      value: "/nos-evenements",
    },
    {
      text: "Page Nous rejoindre",
      value: "/joindre-notre-reseau",
    },
    {
      text: "Page Thérapie",
      value: "/therapie-par-poseidon",
    },
    {
      text: "Page Nos articles",
      value: "/nos-articles",
    },

    { text: "Page Spa Limited Line", value: "/gamme/spa-limited-line" },

    { text: "Page Spa Divine Line", value: "/gamme/spa-divine-line" },

    { text: "Page Spa Sublime Line", value: "/gamme/spa-sublime-line" },

    { text: "Page Classic Line", value: "/gamme/spa-divine-line" },
    { text: "Page Premium Line", value: "/gamme/spa-premium-line" },

    {
      text: "Page Spa de Nage River Jet",
      value: "/gamme/spa-de-nage-river-jet",
    },

    {
      text: "Page Page Spa de Nage Turbine",
      value: "/gamme/spa-de-nage-turbine",
    },

    { text: "Page Sauna Finlandais", value: "/gamme/sauna-finlandais" },

    { text: "Page Sauna Infrarouge", value: "/gamme/sauna-infrarouge" },
  ];
  const checkValue = (valeur) => {
    if (valeur) {
      if (valeur[0] === "/") {
        return { type: 0, tab: sitePages };
      } else if (valeur.includes("product")) {
        return { type: 1, tab: productsIdAndNames };
      } else {
        return 2;
      }
    } else return {};
  };
  const [groupSelected, setgroupSelected] = useState(
    checkValue(value).tab || []
  );

  const handleChangeType = (value) => {
    settypeSelected(value);
    if (value === 0) {
      setgroupSelected(sitePages);
    } else if (value === 1) {
      setgroupSelected(productsIdAndNames);
    }
  };

  return (
    <div className="row">
      <div className="col-6">
        <label className="f16 ">Type du bouton </label>
        <Form.Select
          onChange={(e) => handleChangeType(parseInt(e.target.value))}
          defaultValue={checkValue(value).type}
        >
          {buttonTypes.map((el, index) => (
            <option key={index} value={el.value}>
              {el.text}
            </option>
          ))}
        </Form.Select>
      </div>
      <div className="col-6">
        <label className="f16 ">Déstination du bouton </label>
        {typeSelected !== 2 ? (
          <Form.Select
            onChange={(e) => handleChange(e.target.value)}
            defaultValue={value}
          >
            {groupSelected.map((el, index) => (
              <option key={index} value={el.value}>
                {el.text}
              </option>
            ))}
          </Form.Select>
        ) : (
          <input
            type="text"
            className="styleInput w-100 ps-3 rounded-3 "
            defaultValue={value}
            onChange={(e) => handleChange(e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

export default CustomSelect;
